import { ref } from "vue";

/**
 * 键盘按键状态追踪
 * @param {string} targetKey - 要监听的按键
 * @returns {import('vue').Ref<boolean>} 按键状态
 */
export const useKeyboardState = (targetKey) => {
  const isKeyPressed = ref(false);

  const handleKeyDown = (event) => {
    if (event.key === targetKey) {
      isKeyPressed.value = true;
    }
  };

  const handleKeyUp = (event) => {
    if (event.key === targetKey) {
      isKeyPressed.value = false;
    }
  };

  const setupKeyboardEvents = () => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
  };

  const cleanupKeyboardEvents = () => {
    window.removeEventListener("keydown", handleKeyDown);
    window.removeEventListener("keyup", handleKeyUp);
  };

  return {
    isKeyPressed,
    setupKeyboardEvents,
    cleanupKeyboardEvents,
  };
};
